import { faSearch } from '@fortawesome/pro-regular-svg-icons';
import { HStack, Icon, TextField } from '@nettbureau/vibrant-ui';
import { useTranslate } from '@tolgee/react';

interface SearchBoxProps {
  query: string;
  setQuery: (query: string) => void;
}

export function SearchBox({ query, setQuery }: SearchBoxProps) {
  const { t } = useTranslate();

  return (
    <TextField
      size="lg"
      aria-label="search"
      value={query}
      onChange={setQuery}
      placeholder={t('search')}
      variant="soft"
    >
      <HStack align="center" gap="md">
        <Icon size="sm" icon={faSearch} />
        <TextField.Input />
      </HStack>
    </TextField>
  );
}
